<template>
  <base-index
    ref="baseIndex"
    :columns="columns"
    :resourceName="resourceName"
    :pk="pk"
    :disabledFilterButton="false"
    :breadcrumbs="breadcrumbs"
  >
  </base-index>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      resourceName: "masters",
      pk: "id",
      columns: [
        {
          value: "keyword",
          text: "value",
          filter: true
        },
        {
          value: "group",
          text: "グループ",
          filter: true
        },
        {
          value: "representing",
          text: "メインフラグ",
          filter: true
        },
        {
          value: "editor",
          text: "作成（編集）者",
          filter: true
        },
        {
          value: "status",
          text: "有効/無効",
          filter: true,
          type: "select",
          optionType: "common/master_status"
        }
      ]
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "マスタ一覧",
          disabled: true
        }
      ];
    }
  },
  created(){
  }
};
</script>
